const state = {
    quotations: [],
    quotationId: [],
    newQuotation: {},
    loading: false,
    documents: [],
    file: null,
    docLoader: false,
};

export default state;